<template>
  <b-col>
    <b-row>
      <EasyDataTable
        :headers="fields"
        :items="showTestMethods()"
        :alternating="true"
        :rows-per-page="10000"
        :hide-rows-per-page="true"
      >
        <template #expand="item">
          <EasyDataTable
            :headers="normGroupFields"
            :items="item.normGroups.filter(n => n.selected)"
            :alternating="true"
            :rows-per-page="10000"
            :hide-rows-per-page="true"
          >
          </EasyDataTable>
        </template>
      </EasyDataTable>
    </b-row>
  </b-col>
</template>

<script>
export default {
  name: 'test-method-table',
  props: {
    testMethods: {}
  },
  computed: {
    fields() {
      return [
        { value: 'name', text: this.$t('name') },
        { value: 'show_details', text: ' ' }
      ]
    },
    normGroupFields() {
      let f = [
        {
          value: 'name',
          text: this.$t('privatePage.normgroups_header'),
          sortable: true
        }
      ]
      return f
    }
  },
  methods: {
    showTestMethods() {
      let filteredTestMethods = []

      this.testMethods.forEach(tm => {
        if (tm.normGroups.filter(n => n.selected).length > 0) {
          filteredTestMethods.push(tm)
        }
      })

      return filteredTestMethods
    }
  }
}
</script>
